module.exports = __webpack_public_path__ + "img/zscustomerqrcode.bb36fb77.png";